import { CellPlugin } from '@react-page/editor';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

// use a type here, not an interface
type Data = {
  label: string,
  value: string
}

const getValue = (value: string) => {
  if (value && value.length > 0) {
    return value;
  } else {
    return "123456789";
  }
}

const CheckingAccountNumberPropertyPlugin: CellPlugin<Data> = {
  Renderer: ({ data }) => (
      <Row>
        <Col><strong>{data.label}</strong></Col>
        <Col>{getValue(data.value)}</Col>
      </Row>
  ),
  id: 'checkingAccountNumberPropertyPlugin',
  title: 'Checking Account Number Property',
  description: 'Checking Account Number Property.',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      properties: {
        label: {
          type: 'string',
          default: 'Checking Account Number',
        },
      },
      required: ['label'],
    },
  },
};

export default CheckingAccountNumberPropertyPlugin;